<template>
  <v-container fluid>
    <v-row dense>
    <v-col cols="12">
        <v-file-input
        v-model="chosenFile"
        show-size small-chips
        truncate-length="50"
        @change="dataShow"
        outlined
        dense>
        </v-file-input>
    </v-col>
    <v-col cols="12">
    </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    chosenFile: null,
    data: null
  }),
  components: {},
  methods: {
    dataShow (data) {
      const formData = new FormData()
      formData.append('cave', data)
      console.log(formData.getAll('cave'))
      console.log('data', data)
    }
  }
}
</script>

<style>

</style>
